export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.5017dab5.eot";